/* eslint-disable jsx-a11y/anchor-is-valid */
import { Typography, Grid, Divider, TextField } from '@mui/material';
import React from 'react';
import { LoadingButton } from '@mui/lab';
import { ToastContainer, toast } from 'react-toastify';
import { Formik } from 'formik';
import * as Yup from 'yup';
import {
  ContainerForm,
  ContainerFormProfile
} from '../../components/auth/CreateUser/createUserStyles';
import { colors } from '../../constants/colors';
import { ErrorText } from '../../components/layout/main/mainStyles';
import { ContainerImage } from '../registration/registrationViewStyles';

const havenLogo = require('../../assets/logo.png');

const deleteAccountValidator = Yup.object().shape({
  email: Yup.string().email('Invalid email').required('Email is required')
});

const sendDeleteRequest = async ({ email }: { email: string }) => {
  return new Promise((resolve) => {
    setTimeout(() => resolve({ success: true }), 1000);
  });
};

export const DeleteAccount = () => {
  return (
    <ContainerImage>
      <Grid
        container
        spacing={2}
        direction="row"
        justifyContent="left"
        alignItems="center"
      >
        <Grid item xs={0.5} md={2} />
        <Grid item xs={11} md={6} lg={3.5}>
          <ContainerForm container padding={3} justifyContent="center">
            <Grid item xs={12} textAlign="center">
              <img src={havenLogo} alt="Haven Logo" width={200} />
            </Grid>

            <Grid item xs={12}>
              <Typography
                align="center"
                marginY={3}
                variant="h5"
                fontWeight="bold"
                color={colors.strongGray}
                paddingTop={2}
              >
                Account Deletion
              </Typography>
            </Grid>

            <Grid item xs={12} marginBottom={2}>
              <Typography variant="body1" color="text.secondary">
                This page allows you to request the deletion of your account and
                all associated data in compliance with Google Play’s data
                deletion requirements.
              </Typography>

              <Typography variant="h6" marginTop={2}>
                🔐 How to delete your account from the app:
              </Typography>
              <Typography variant="body2" color="text.secondary">
                1. Open the application.
                <br />
                2. Go to <strong>Settings → Account → Delete Account</strong>.
                <br />
                3. Follow the instructions shown on the screen to confirm.
              </Typography>

              <Typography variant="h6" marginTop={2}>
                ❗ Don&apos;t have access to the app?
              </Typography>
              <Typography variant="body2" color="text.secondary">
                If you uninstalled the app, lost your device, or can&rsquo;t log
                in, you can request account deletion by entering the email
                associated with your account:
              </Typography>
            </Grid>

            <ContainerFormProfile item xs={10} md={8} lg={12}>
              <Formik
                enableReinitialize
                validationSchema={deleteAccountValidator}
                initialValues={{ email: '' }}
                onSubmit={async (values, { resetForm }) => {
                  const result = (await sendDeleteRequest(values)) as any;

                  if (result.success) {
                    toast.success(
                      'Your request has been submitted. We will contact you within 24–48 hours.'
                    );
                    resetForm();
                  } else {
                    toast.error('Something went wrong. Please try again.');
                  }
                }}
              >
                {({
                  handleChange,
                  handleSubmit,
                  values,
                  isValid,
                  setFieldTouched,
                  errors,
                  touched,
                  isSubmitting
                }) => (
                  <Grid container spacing={2} justifyContent="center">
                    <Grid item xs={12}>
                      <TextField
                        value={values.email}
                        id="email"
                        label="Email address"
                        onBlur={() => setFieldTouched('email')}
                        onChange={handleChange('email')}
                        name="email"
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                      />
                      {touched.email && errors.email && (
                        <ErrorText>{errors.email}</ErrorText>
                      )}
                    </Grid>

                    <Grid item xs={12} marginTop={1}>
                      <LoadingButton
                        color="info"
                        disabled={!isValid}
                        onClick={() => handleSubmit()}
                        variant="contained"
                        size="large"
                        fullWidth
                        loading={isSubmitting}
                      >
                        Request Account Deletion
                      </LoadingButton>
                    </Grid>
                  </Grid>
                )}
              </Formik>
            </ContainerFormProfile>
          </ContainerForm>
        </Grid>

        <ToastContainer
          newestOnTop
          position="bottom-center"
          draggable
          theme="colored"
          autoClose={4000}
        />

        <Divider variant="fullWidth" />
      </Grid>
    </ContainerImage>
  );
};
